/* TODO: move delete modal messages */

export enum DynamicActionTemplateMessages {
  decommission = "You are about to decommission this asset. You will no longer be able to add it to contracts",
  undecommission = "You are about to rollback this asset decommission. You will be able to add it to contracts",
  assetUpdated = "Asset has been updated",
  terminateContract = "You are about to terminate this contract. All assets linked to this contract will also be terminated.",
  unterminateContract = "You are about to unterminate this contract. All assets linked to this contract will also change their coverage status.",
  terminateContractAsset = "You are about to terminate this asset",
  unterminateContractAsset = "You are about to unterminate this asset",
  contractUpdated = "Contract has been updated",
}
